import Component from "./FlightDetails";

export default Component;
